import Button from "../../Components/Button";
import CheckBox from "../../Components/Checkbox";
import TextInput from "../../Components/TextInput";
import {
  ISahraTableSearchParams,
  ExchangeType,
} from "../../Interfaces/SahraTableInterfaces";
import {
  ISearchparamUI,
  SearchparamStateHandler,
} from "../TableTemplate/tableTemplate";
import React from "react";
// Common components
import { StaticDropdown } from "src/Components";
// Types
import { DropdownItem } from "src/Interfaces/dropdownInterfaces";

const exchangeTypeOption: DropdownItem[] = [
  { id: "", name: "همه" },
  { id: ExchangeType.StockExchange, name: "اوراق بهادار" },
  { id: ExchangeType.CommodityExchange, name: "کالا" },
];

interface IProps {
  searchParamChangeHandler: (name: string, value: any) => void;
  searchParam: ISahraTableSearchParams;
  onSubmit: () => void;
}

export const SahraUsersTableSarchParamUI: React.FC<IProps> = ({
  searchParamChangeHandler,
  searchParam,
  onSubmit,
}) => {
  return (
    <div className="rounded p-3 flex flex-col gap-3 !w-[300px] h-fit mt-6 shadow-[0px_2px_1px_-1px_rgba(0,0,0,0.2),0px_1px_1px_0px_rgba(0,0,0,0.14),0px_1px_3px_0px_rgba(0,0,0,0.12)]">
      <span className="text-sm font-bold">مقادیر جستجو</span>
      <div className="w-[250px] flex flex-col justify-start items-start gap-2">
        <TextInput
          label="نام "
          name="name"
          onChange={searchParamChangeHandler}
          value={searchParam.name}
        />
        <TextInput
          label="نام کاربری"
          name="username"
          onChange={searchParamChangeHandler}
          value={searchParam.username}
        />
        <StaticDropdown
          dropdown={{
            name: "exchangeType",
            placeholder: "بورس",
            extraLabel: false,
          }}
          onChange={searchParamChangeHandler}
          options={exchangeTypeOption}
          value={searchParam.exchangeType}
        />
        <CheckBox
          checked={searchParam.justActive || false}
          label="فقط فعال"
          name="justActive"
          onChange={searchParamChangeHandler}
        />
        <Button
          onClick={onSubmit}
          text="جستجو"
          variant="contained"
          className="mt-3 bg-sky-600"
        />
      </div>
    </div>
  );
};
